import {
  Box,
  Checkbox,
  Divider,
  FormControl,
  FormControlLabel,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import React from "react";
import { sizes } from "../scenarioSetupNewUtils";
import { useDispatch, useSelector } from "react-redux";
import { setState } from "../scenarioSetupNewSlice";
import BreakdownUpload from "./BreakdownUpload";
import MarketShareComparisonModal from "./MarketShareComparisonModal";
import BreakdownSKUUpload from "./BreakdownSKUUpload";

const commonHeight = sizes.h35;
const SW = sizes.w300;
const MW = sizes.w300;

export default function CustomerBdMethod() {
  const dispatch = useDispatch();
  const setupState = useSelector((store) => store.scenarioSetupNew);
  const {
    customerBreakdownType,
    customerBreakdown,
    CBDMType,
    CBDMPeriod,
    scenarioExternalDataSource,
    MarketShareTimePeriod,
    marketShareComparisonList,
    skuBreakdown,
    selectedDSs,
    scenarioExternalDataSourceSKU,
    selectedScSTQ,
    scenarioSTQ,
  } = setupState;
  const handleStateUpdate = (event, stateName) => {
    const value = event.target.value;
    dispatch(setState(stateName, value));
    if (stateName === "customerBreakdownType") {
      if (
        value !== "Scenario SKUs" &&
        value !== "Reference SKUs" &&
        value !== "Dynamic Market Share"
      ) {
        dispatch(setState("customerBreakdown", ""));
      }else{
        if(customerBreakdown === undefined || customerBreakdown === null || customerBreakdown === ""){
          dispatch(setState("customerBreakdown", "3 months"));
        }
      }
      if (value != "External") {
        dispatch(setState(scenarioExternalDataSource, []));
      }
    } else if (stateName == "customerBreakdown") {
      if (
        marketShareComparisonList == null ||
        marketShareComparisonList.length === 0
      ) {
        dispatch(setState("MarketShareTimePeriod", value));
        dispatch(setState("PreviousMarketShareTimePeriod", value));
      }
    }
    else if (stateName == "skuBreakdown") {
      if (value != "External") {
        dispatch(setState(scenarioExternalDataSourceSKU, []));
      }
    }
  };

  // const handleCheckedUpdate = (event, stateName) => {
  //   const option = event.target.checked;
  //   dispatch(setState(stateName, option));
  // };

  return (
    <Box>
      <Box sx={{ mt: 2 }}>
        <Grid container spacing={2} columns={12} alignContent={"space-between"}>
          <Grid item sm={12}>
            <Box
              sx={{
                border: 1,
                borderRadius: 1,
                p: 2,
                borderColor: "#c6c6c6",
              }}
            >
              <Typography varient="subtitle2" mb={3} fontWeight={600} fontSize={14} sx={{ color: "#131314" }}>Breakdown Methodology</Typography>
              <Grid
                container
                spacing={1}
                columns={12}
                alignContent={"space-between"}
              >
                <Grid item sm={12} md={6} lg={6} xs={6}>
                  <Box>
                    <FormControl sx={{ width: "100%", }}>
                      <InputLabel id="demo-simple-select-label">
                        Customer Breakdown Methodology
                      </InputLabel>
                      <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        value={customerBreakdownType}
                        label="Country"
                        onChange={(event) =>
                          handleStateUpdate(event, "customerBreakdownType")
                        }
                      >
                        {CBDMType.map((type, index) => {
                          return (
                            <MenuItem key={index} value={type}>
                              {type}
                            </MenuItem>
                          );
                        })}
                      </Select>
                    </FormControl>
                  </Box>
                </Grid>
                <Grid item sm={12} md={6} lg={6} xs={6}>
                {(customerBreakdownType === "Scenario SKUs" ||
                  customerBreakdownType === "Reference SKUs" ||
                  customerBreakdownType === "Dynamic Market Share") && (
                      <Box>
                        <FormControl sx={{ width: "100%" }}>
                          <InputLabel id="demo-simple-select-label">
                            Period
                          </InputLabel>
                          <Select
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            value={customerBreakdown}
                            label="Country"
                            sx={{
                              height: commonHeight,
                              width: SW,
                              color: "black.main",
                              mt: 1,
                            }}
                            onChange={(event) =>
                              handleStateUpdate(event, "customerBreakdown")
                            }
                          >
                            {CBDMPeriod.map((period, index) => {
                              return (
                                <MenuItem key={index} value={period}>
                                  {period}
                                </MenuItem>
                              );
                            })}
                          </Select>
                        </FormControl>
                      </Box>
                  )}
                </Grid>
                {customerBreakdownType === "External" && (
                  <Grid item sm={12} md={12} lg={12} xs={12}>
                    <Box>
                      <BreakdownUpload />
                    </Box>
                  </Grid>
                )}

                <Grid item sm={10} md={4} lg={6} mt={2} xs={6}>
                  <Box>
                    <FormControl sx={{ width: "100%", }}>
                      <InputLabel id="demo-simple-select-label">
                        SKU Breakdown Methodology
                      </InputLabel>
                      <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        value={skuBreakdown}
                        label="SKU Breakdown Methodology"
                        sx={{
                          height: commonHeight,
                          width: SW,
                          color: "black.main",
                        }}
                        onChange={(event) =>
                          handleStateUpdate(event, "skuBreakdown")
                        }
                      >
                        {selectedDSs?.map((source, index) => {
                          if (source !== "Forecast" && source != 'SIT') {
                            return (
                              <MenuItem key={index} value={source}>
                                {source}
                              </MenuItem>
                            );
                          }
                          return null;
                        })}
                        <MenuItem value={"External"}>External</MenuItem>
                      </Select>
                    </FormControl>
                  </Box>
                </Grid>
                <Grid item sm={12} md={6} lg={6} mt={0}>
                  <Box sx={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "flex-start",
                    float: "right"
                  }}>
                    <MarketShareComparisonModal />
                  </Box>
                </Grid>
                {(skuBreakdown === "External") && (
                  <Grid item sm={12} md={12} xs={12} lg={12}>
                    <Box>
                      <BreakdownSKUUpload />
                    </Box>
                  </Grid>
                )}
              </Grid>
            </Box>
          </Grid>
          {/* <Grid item sm={5.95} md={5.95} lg={5.95} xs={5.95}>
						<Box>
							<FormControl sx={{width:"100%"}}>
								<InputLabel id="demo-simple-select-label">
									Scenario Stick to Quota
								</InputLabel>
								<Select
									labelId="demo-simple-select-label"
									id="demo-simple-select"
									value={selectedScSTQ}
									label="Scenario Stick to Quota"
									sx={{
										height: commonHeight,
										width: SW,
										color: "black.main",
										mt: 1,
									}}
									onChange={(event) =>
										handleStateUpdate(event, "selectedScSTQ")
									}
								>
									{scenarioSTQ.map((item, index) => {
										return (
											<MenuItem key={index} value={item.value}>
												{item.value}
											</MenuItem>
										);
									})}
								</Select>
							</FormControl>
						</Box>
          </Grid> */}
        </Grid>
      </Box>

    </Box>
  );
}
